import axios from 'axios';
import { matchPath } from 'react-router-dom';
import { API_URL } from 'config';
import { mailResourceRequestPath } from 'routes/paths';

const axiosServices = axios.create({ baseURL: API_URL });

axiosServices.interceptors.response.use(
    response => response,
    error => {
        if (
            !matchPath(mailResourceRequestPath(), window.location.pathname) &&
            error.response.status === 401 &&
            !window.location.href.includes('/login')
        ) {
            window.location.pathname = '/login';
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);

export default axiosServices;
